import _ from "lodash"

const checkIsHaveEmptyPaidAmt = (array, message = 'Amount field is required for paid holiday') => {
  if (_.isArray(array)) {
    const isHaveEmptyPaidAmount = array?.some((i) => (i?.paid && !i?.amount));
    return isHaveEmptyPaidAmount ? message : '';
  }
}

export default checkIsHaveEmptyPaidAmt;